export default __webpack_public_path__ + "static/media/ckb-logo.86fac089.svg";